import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const BajaColaboradorProcedimiento = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/baja-colaborador-proceso.pdf`;
  /*const pdfUrl = "/pdf/baja-colaborador-proceso.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Solicitud de Baja de Colaborador</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Solicitud de Baja de Colaborador" />
      </Container>
    </>
  );
};

 export default BajaColaboradorProcedimiento;
